
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6a23dbd6f8139bac36d5d7c9";
              window.beaePageSetting.pageTitle = "Become A Dealer"; 
              window.beaePageSetting.pageType = "page";

          let js_NULK9USL = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-81btskdbsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-81btskdb',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-81btskdb');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-81btskdb: ', ex)
      };
    

      try {
        let argid = 'beae-kvk41g7ablock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-kvk41g7a',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-kvk41g7a');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-kvk41g7a: ', ex)
      };
    

      try {
        let argid = 'beae-9a386i1xblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9a386i1x',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9a386i1x');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9a386i1x: ', ex)
      };
    

      try {
        let argid = 'beae-vuxthchwblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-vuxthchw',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-vuxthchw');
        args.el = args.els[0];
        ((P) => { var I;let O=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");O==null||O.forEach(z=>{let H=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(H!=null&&H.includes("#"))&&z.addEventListener("click",A=>{let R=document.querySelector(H+","+(H==null?void 0:H.replace("#",".")));if(R)return R.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-vuxthchw: ', ex)
      };
    

      try {
        let argid = 'beae-zqhys8q7block-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zqhys8q7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zqhys8q7');
        args.el = args.els[0];
        ((h) => { const g=window.location.href.indexOf("contact_posted=true")!==-1,u=h.el.querySelector("form");h.el.querySelector(".beae-btn-pr");const f=h.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),b=h.el.querySelector(".btn-lightbox-form > button");!g&&h.mode.value!=="builder"&&(h.el.querySelector(".beae-form-success-message").style="display: none"),g&&h.afterSubmitting=="redirect"&&h.redirect&&(h.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=h.redirect);const k=[];u&&u.addEventListener("submit",m=>{m.preventDefault();for(let y=0;y<f.length;y++)k.push({fieldKey:f[y].name,fieldType:f[y].type,fieldValue:f[y].value})}),b&&(b.onclick=()=>{const m=document.createElement("div");m.innerHTML=u.outerHTML||"",window.BeaePopupLibrary.createPopup(m,{layout:"center",layoutMobile:"bottom",width:"500px",id:h.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zqhys8q7: ', ex)
      };
    }; if (window.BEAEBASE) {js_NULK9USL()} else {window.BEAEPAGEJS.push(js_NULK9USL)} })(); 